/*!
 * True Cost Widget — Petit Pli
 * The widget is rendered in Liquid (sections/true-cost-widget.liquid) with the
 * shopper's currency and the live product price. This script only makes the
 * slider interactive: it updates the numbers already on the page.
 * No third-party requests.
 */

(function () {
  'use strict';

  // Same output as Liquid's money_without_trailing_zeros for the shop's money
  // format in the active currency (e.g. "£{{amount}}", "{{amount_with_comma_separator}} kr").
  function moneyFormatter(format, code) {
    var fmt = format || '';
    if (fmt.indexOf('&') !== -1) {
      var ta = document.createElement('textarea');
      ta.innerHTML = fmt;
      fmt = ta.value;
    }
    var seps = {
      amount: [',', '.'],
      amount_no_decimals: [',', '.', 0],
      amount_with_comma_separator: ['.', ','],
      amount_no_decimals_with_comma_separator: ['.', ',', 0],
      amount_with_apostrophe_separator: ["'", '.'],
      amount_no_decimals_with_space_separator: [' ', ',', 0],
      amount_with_space_separator: [' ', ','],
      amount_with_period_and_space_separator: [' ', '.']
    };
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var sep = m && seps[m[1]];
    if (!sep) {
      var intl = null;
      try {
        intl = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: code || 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0
        });
      } catch (e) {}
      return function (n) { return intl ? intl.format(Math.round(n)) : String(Math.round(n)); };
    }
    return function (n) {
      var parts = (sep[2] === 0 ? Math.round(n).toFixed(0) : Number(n).toFixed(2)).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]);
      var frac = parts[1] && !/^0+$/.test(parts[1]) ? sep[1] + parts[1] : '';
      return fmt.replace(m[0], whole + frac);
    };
  }

  function bind(root) {
    if (root.dataset.tcwBound) return;
    var slider = root.querySelector('.tcw-slider');
    if (!slider) return;
    root.dataset.tcwBound = '1';

    var d = root.dataset;
    var code = d.currency || 'GBP';
    var sizes = parseInt(d.sizes, 10) || 7;
    var pp = parseFloat(d.ppPrice) || 0;
    var min = parseFloat(slider.min) || 0;
    var max = parseFloat(slider.max) || 100;
    var vinted = parseFloat(d.vinted) || 0;

    var fmt = moneyFormatter(d.moneyFormat, code);
    var states = root.querySelectorAll('[data-tcw-state]');
    var q = function (name) { return root.querySelectorAll('[data-tcw="' + name + '"]'); };
    var setText = function (name, text) { q(name).forEach(function (el) { el.textContent = text; }); };

    function update() {
      var price = parseInt(slider.value, 10) || min;
      var total = price * sizes;
      var pct = max > min ? ((price - min) / (max - min)) * 100 : 0;
      slider.style.setProperty('--fill', pct.toFixed(1) + '%');
      slider.setAttribute('aria-valuetext', fmt(price) + ' per garment');
      setText('price', fmt(price));
      setText('other-per', fmt(price));
      setText('other-total', fmt(total));
      var state = price < vinted ? 'vinted' : (total - pp > 0 ? 'positive' : 'neutral');
      states.forEach(function (el) { el.hidden = el.getAttribute('data-tcw-state') !== state; });
    }

    slider.addEventListener('input', update);

    // Analytics: one event per adjustment, debounced so holding an arrow key
    // sends one event, not dozens. GA4: Shopify's Google integration defines
    // window.gtag in the page at runtime (config G-QPZPB2V8CC), so the event
    // goes straight to that property. It is also published as a Shopify
    // customer event, which a custom pixel can subscribe to if ever needed.
    var sendTimer = null;
    slider.addEventListener('change', function () {
      clearTimeout(sendTimer);
      sendTimer = setTimeout(function () {
        var payload = { currency: code, price: parseInt(slider.value, 10) };
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'petitpli_widget_slider_changed', {
              currency: payload.currency,
              price: payload.price,
              send_to: 'G-QPZPB2V8CC'
            });
          }
        } catch (e) {}
        try {
          var a = window.Shopify && window.Shopify.analytics;
          if (a && typeof a.publish === 'function') a.publish('petitpli_widget_slider_changed', payload);
        } catch (e) {}
      }, 800);
    });

    // Nudge the slider thumb once, when the widget first comes into view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('is-inview');
          io.disconnect();
        });
      }, { threshold: 0.3 });
      io.observe(slider);
    }

    // Keep the fill in sync if the browser restored a different slider value.
    if (String(slider.value) !== String(slider.defaultValue)) update();
  }

  function init() {
    document.querySelectorAll('[data-true-cost-widget]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
